'use client'

import React from 'react'
import { X } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import TerpeneBrowserSection from './TerpeneBrowserSection'

interface TerpeneBrowserModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export default function TerpeneBrowserModal({ 
  open, 
  onOpenChange 
}: TerpeneBrowserModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent 
        hideOverlay 
        className="w-[95vw] sm:w-[calc(100vw-32px)] max-w-[95vw] sm:max-w-[calc(100vw-32px)] max-h-[calc(100vh-60px)] sm:max-h-[calc(100vh-100px)] overflow-y-auto rounded-lg sm:rounded-2xl p-3 sm:p-6 bg-white/5 backdrop-blur-xl border border-white/20"
        style={{
          boxShadow: '0 8px 32px 0 rgba(15, 20, 25, 0.37), 0 0 30px rgba(215, 164, 73, 0.3)'
        }}
      >
        <DialogHeader className="pb-4">
          <DialogTitle className="text-2xl text-white flex items-center justify-between">
            <div className="bg-gradient-to-r from-emerald-400 via-green-300 to-emerald-400 bg-clip-text text-transparent font-bold">
              Terpene Effects Browser
            </div>
            <Button
              onClick={() => onOpenChange(false)}
              variant="ghost"
              size="sm"
              className="text-white/60 hover:text-white hover:bg-white/10 h-8 w-8 p-0"
            >
              <X className="h-4 w-4" />
            </Button>
          </DialogTitle>
          <DialogDescription className="text-white/70">
            Explore cannabis terpenes with detailed effects, natural sources, and research-backed information.
          </DialogDescription>
        </DialogHeader>

        {/* Main Browser Section */}
        <div className="w-full overflow-hidden">
          <TerpeneBrowserSection />
        </div>
      </DialogContent>
    </Dialog>
  )
}